<template>
    <TprmModal
        open
        title="Go to Entity Details"
        additional-class-name="DocumentDataReviewGoToEntityDetailsModal"
        size="default"
        :allow-close="false"
        @close="$emit('close')"
    >
        Are you sure you want to leave this page? All changes will be lost.

        <template #footer>
            <NewButton
                variant="outline"
                color="neutral"
                @click="$emit('input', false)"
            >
                Cancel
            </NewButton>
            <NewButton
                variant="fill"
                color="primary"
                @click="$emit('input', true)"
            >
                Confirm and Leave
            </NewButton>
        </template>
    </TprmModal>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    export default defineComponent({
        name: 'DocumentDataReviewGoToEntityDetailsModal',
        components: {
            TprmModal,
            NewButton,
        },
        emits: [ 'close', 'input' ],
    });
</script>
